import React from 'react';
import Navbar from './Navbar';
import Sticker from './Sticker';
import Services from './Services';
import Features from './Features';
import Screens from './Screens';
import Download from './Download';
import Reviews from './Reviews';
import Footer from './Footer';

const Home = () => (
  <div id="landingPage">
    <Navbar />
    <main>
      <Sticker />
      <Services />
      <Features />
      <Screens />
      <Download />
      <Reviews />
      <Footer />
    </main>
  </div>
);

export default Home;
